"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const iconWrapper_helper_1 = require("./iconWrapper.helper");
const IconWrapper_styled_1 = require("./IconWrapper.styled");
const IconWrapper_types_1 = require("./IconWrapper.types");
function IconWrapper({ size = IconWrapper_types_1.IconSize.Medium, color = IconWrapper_types_1.IconColor.DigitalBlack, viewBox, className, onClick, name }, icon) {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const iconSize = (0, iconWrapper_helper_1.useNumSize)({ size });
    const iconColor = (0, iconWrapper_helper_1.useIconColor)({ color });
    return (react_1.default.createElement(IconWrapper_styled_1.StyledIcon, { viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : '0 0 24 24', className: className, color: iconColor, size: iconSize, onClick: onClick, theme: theme, "data-testid": `icon-${name || 'component'}` }, icon));
}
exports.default = IconWrapper;
//# sourceMappingURL=IconWrapper.js.map